import { CheckCircleIcon } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface SuccessProps {
  title: string;
  description?: string;
}

export default function Success({ title, description }: SuccessProps) {
  return (
    <Alert className="after:bg-emerald-500 text-emerald-600 dark:text-emerald-400">
      <CheckCircleIcon />
      <AlertTitle>{title}</AlertTitle>
      {description && <AlertDescription>{description}</AlertDescription>}
    </Alert>
  );
}
